"use no memo";

import React from 'react';

import poweredBySrc from 'static/images/icon-poweredby.svg';

export const PoweredByBadge: React.FunctionComponent = () => (
  <img alt="Powered by ChowNow" src={poweredBySrc} />
);
